import {useHttp} from "./http.hook";
import {IStrategiesInfo, IStrategySettings} from "../shared/types";

interface IDataGetAll {
  message: string,
  info: IStrategySettings[]
}

interface IDataStrategiesInfo {
  message: string,
  info: IStrategiesInfo
}

interface IDataSaveSettings {
  message: string,
}

interface IDataGetExpertStrategy {
  message: string,
  info: boolean
}

export const useSettings = () => {

  const {loading, request, error, clearError} = useHttp()

  // //получение всех настроек по всем стратегиям
  // const getAllSettings = async () => {
  //   try {
  //     const data: IDataGetAll = await request('/api/settings', 'GET')
  //     return data
  //   } catch (e) {
  //     throw e
  //   }
  // }

  //получение всех настроек по переданному списку стратегий
  const getSettingsByStrategyList = async (strategies: string[]) => {
    try {
      const data: IDataGetAll = await request('/api/settings/by-strategy-list', 'POST', {
        strategies: strategies,
      })
      return data
    } catch (e) {
      throw e
    }
  }

  //сохранение настроек для одной выбранной стратегии
  const saveSettingsForStrategy = async (strategy: string, enable: boolean, settings: string) => {
    try {
      const data: IDataSaveSettings = await request('/api/settings/save-one', 'POST', {
        strategy: strategy,
        enable: enable,
        settings: settings
      })
      return data
    } catch (e) {
      throw e
    }
  }

  //получение всех настроек по переданному списку стратегий
  const getAllStrategiesInfo = async () => {
    try {
      const data: IDataStrategiesInfo = await request('/api/settings/get-strategies-info', 'POST', {})
      return data
    } catch (e) {
      throw e
    }
  }

  return {
    loading,
    saveSettingsForStrategy,
    getSettingsByStrategyList,
    getAllStrategiesInfo,
    error,
    clearError
  }
}